export default __webpack_public_path__ + "static/media/clientCase2.dedd6f43.png";